import React,{ useState } from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import logo from '../images/hii.png'

import { BrowserRouter, Route, Link } from "react-router-dom";

function Header() {
	const [burgerStatus, setBurgerStatus] = useState(false)

	const changeBurgerStatus = () => {
		setBurgerStatus(!burgerStatus)
		const bodySelect = document.querySelector("body")
		bodySelect.classList.toggle("hideScroll")		
	}

	return (
		<Container>
			<a >
				<img src={logo} id='navlogo' alt="logo" height={"80px"} />
			</a>
			<Menu >
			<Fade bottom>
			    <Link to="/" className='nav'>Home</Link>
				<Link to="/about" className='nav'>Club Lead</Link>
				<Link to="/ev" className='nav'>Events</Link>
				<Link to="/contact" className='nav'>Contact Us</Link>
				</Fade>
			</Menu>
			<RightMenu>
				<CustomMenu onClick={ changeBurgerStatus } />
			</RightMenu>
				<BurgerNav show={burgerStatus}>
					<CloseWrapper>
						<CustomClose onClick={ changeBurgerStatus } />
					</CloseWrapper>
					<Fade bottom>
					<li> <Link to="/" className='nav'>Home</Link> </li>
					<li> <Link to="/about" className='nav'>Club Lead</Link> </li>
					<li> <Link to="/ev" className='nav'>Events</Link> </li>
					<li> <Link to="/contact" className='nav'>Contact Us</Link> </li>
					</Fade>
				</BurgerNav>
		</Container>
	)
}

export default Header

const Container = styled.div `
	position: fixed;
	min-height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1;

	background-color: rgba( 255, 255, 255, 0.5);
	box-shadow: 0 35px 55px rgba(0, 0, 0, 0.1);

	@media(max-width: 400px){
		max-width: 100vw;
		min-height: 40px;
		a{
			img{
				width: 75px;
			}
		}
	}
`

const Menu = styled.div `
    color : green;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	
	a{
		color: black;
		font-weight: 600;
		text-transform: uppercase;
		padding: 0 10px;
		white-space: nowrap;
	}

	@media(max-width: 768px){
		display: none;
	}
`

const RightMenu = styled.div `
	display: flex;
	align-items: center;
	a{
		color: black;
		font-weight: 600;
		text-transform: uppercase;
		margin-right: 10px;
		white-space: nowrap;
	}

`

const CustomMenu = styled(MenuIcon) `
	cursor: pointer;
`

const BurgerNav = styled.div `
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	background: rgba( 255, 255, 255, 1);
	width: 300px;
	z-index: 16;
	list-style: none;
	padding: 20px;
	display: flex;
	flex-direction: column;
	text-align: start;

	transform: ${ props => props.show ? 'translateX(0)' : 'translateX(100%)'};
	transition: transform 0.2s ease-in-out;

	overflow-y: scroll ;
	
	li{
		padding: 15px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);

		a{
			color: black;
			font-weight: 600;
		}
	}

	::-webkit-scrollbar {
  	display: none;
	}
`

const CloseWrapper = styled.div `
	display: flex;
	justify-content: flex-end;
`

const CustomClose = styled(CloseIcon) `
	cursor: pointer;
`